import React from 'react';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import TextEditorModal from './TextEditorModal';

const INSTRUCTIONS_COLOR = {
  softBg: 'rgba(71, 85, 105, 0.09)',
  text: '#475569',
};

export default function InstructionsEditor({ open, onClose, value = '', onSave }) {
  return (
    <TextEditorModal
      open={open}
      onClose={onClose}
      title="Project Instructions"
      nodeIcon={<ArticleOutlinedIcon sx={{ fontSize: 16 }} />}
      nodeColor={INSTRUCTIONS_COLOR}
      value={value}
      onSave={onSave}
      placeholder={"Provide instructions for users working with this project...\n\nExamples:\n• Upload clear audio files for best transcription results\n• Speak clearly and avoid background noise\n• Provide context about the topic being discussed\n• Review generated content before final export"}
    />
  );
}
